(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yc-product"]) return;
  try {
    
  /* L'avis de Yumi : le chat est cale au bas de la carte et l'arc qui ecarte
     le texte doit suivre exactement sa position. Or la hauteur de la carte
     depend du texte : le CSS seul ne peut pas la connaitre. On mesure donc,
     on pose, on remesure. La hauteur ne peut que CROITRE d'une passe a
     l'autre (ajouter l'exclusion ne retire jamais de ligne), donc la boucle
     converge et s'arrete d'elle-meme. Quatre passes au plus, par securite. */
  (function () {
    function cale(el) {
      var corps = el.querySelector('.yc-avis__body');
      if (!corps) return;
      /* On mesure le CORPS, jamais la carte. La carte contient le flottant :
         la mesurer revenait a mesurer sa propre pose, chaque passe ajoutait sa
         hauteur a la suivante et la carte s'allongeait sans fin - c'est ce qui
         poussait le chat vers le bas en fenetre etroite. La hauteur du corps,
         elle, ne depend que du texte.

         Deux valeurs sont posees :
           --yc-avis-push : de combien le TEXTE descend quand la carte est plus
             haute que lui (plancher impose par la mascotte). C'est le texte qui
             va chercher le chat, jamais l'inverse.
           --yc-avis-wrap : hauteur de la cale, du haut du contenu jusqu'au bas
             de la carte, pour que l'arc tombe pile sur le chat.
         Trois passes au plus, et on s'arrete des que rien ne bouge. */
      var st = getComputedStyle(el);
      var haut = parseFloat(st.paddingTop) || 0;
      var bas = parseFloat(st.paddingBottom) || 0;
      var plancher = parseFloat(st.minHeight) || 0;
      el.style.setProperty('--yc-avis-push', '0px');
      el.style.setProperty('--yc-avis-wrap', '0px');
      var pousse = -1;
      var pose = -1;
      for (var i = 0; i < 3; i++) {
        var texte = corps.getBoundingClientRect().height;
        var p = Math.max(0, plancher - (haut + texte + bas));
        var w = p + texte + bas;
        if (Math.abs(p - pousse) < 1 && Math.abs(w - pose) < 1) break;
        pousse = p;
        pose = w;
        el.style.setProperty('--yc-avis-push', pousse + 'px');
        el.style.setProperty('--yc-avis-wrap', pose + 'px');
      }
    }

    function toutes() {
      var lot = document.querySelectorAll('.yc-avis--flow');
      for (var i = 0; i < lot.length; i++) cale(lot[i]);
    }

    /* Yumi vivant (maquette 7A2, validee par le client le 09/10/2026) : quand
       la carte arrive a l'ecran, Yumi entre par la droite, les mots
       s'ecrivent, les empreintes se tamponnent, puis il fait un clin d'oeil.
       Le texte est dans la page des le depart (lu par Google) ; seule son
       apparition est animee. Mouvement reduit demande, ou navigateur sans
       IntersectionObserver : rien n'est cache, rien ne bouge. */
    var anime = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) &&
      'IntersectionObserver' in window && !!Element.prototype.animate;

    function decouper(p) {
      /* Chaque mot dans un <span class="yc-w">. Un signe double (: ; ! ?)
         reste colle au mot precedent par une espace insecable : jamais en
         debut de ligne. */
      var noeuds = [], tw = document.createTreeWalker(p, NodeFilter.SHOW_TEXT), dernier = null;
      while (tw.nextNode()) noeuds.push(tw.currentNode);
      noeuds.forEach(function (n) {
        var frag = document.createDocumentFragment();
        n.nodeValue.split(/(\s+)/).forEach(function (m) {
          if (!m) return;
          if (/^\s+$/.test(m)) { frag.appendChild(document.createTextNode(m)); return; }
          if (/^[:;!?]+$/.test(m) && dernier) {
            if (frag.lastChild && frag.lastChild.nodeType === 3) frag.removeChild(frag.lastChild);
            dernier.textContent += ' ' + m;
            return;
          }
          var s = document.createElement('span');
          s.className = 'yc-w';
          s.textContent = m;
          frag.appendChild(s);
          dernier = s;
        });
        n.parentNode.replaceChild(frag, n);
      });
    }

    function attendre(ms) {
      return new Promise(function (r) { setTimeout(r, ms); });
    }

    function toutMontrer(el) {
      var lot = el.querySelectorAll('.yc-w, .yc-avis__score, .yc-avis__paws > *');
      for (var i = 0; i < lot.length; i++) lot[i].classList.add('is-on');
      var y = el.querySelector('.yc-yumi');
      if (y) { y.style.transform = ''; y.classList.add('is-respire'); }
    }

    async function jouer(el) {
      var y = el.querySelector('.yc-yumi');
      try {
        await attendre(120);
        var entree = y.animate([
          { transform: 'translateX(140%) rotate(9deg)', easing: 'cubic-bezier(.25,.7,.35,1)' },
          { transform: 'translateX(-5%) translateY(-20px) rotate(-5deg)', offset: .55, easing: 'cubic-bezier(.55,0,.9,.45)' },
          { transform: 'translateX(0) translateY(0) scale(1.07,.9)', offset: .76, easing: 'cubic-bezier(.2,.8,.3,1)' },
          { transform: 'scale(.98,1.03)', offset: .9 },
          { transform: 'none' }], { duration: 900, easing: 'linear' });
        y.style.transform = '';
        /* Le texte commence pendant que Yumi atterrit, sans attendre la fin de
           son entree (client, 09/10/2026 : « un tout petit peu plus tot »). */
        var pose = entree.finished.then(function () {
          y.classList.add('is-respire');
          var reflet = y.querySelector('.yc-yumi__reflet');
          if (reflet) reflet.classList.add('is-on');
        });
        await attendre(500);
        /* Les mots : plus vite que la maquette (client, 09/10/2026). Onglet
           cache : les minuteries ralentissent, on montre tout d'un coup. */
        var mots = el.querySelectorAll('.yc-w');
        for (var i = 0; i < mots.length; i++) {
          if (document.hidden) { toutMontrer(el); return; }
          mots[i].classList.add('is-on');
          await attendre(14);
        }
        await attendre(150);
        var score = el.querySelector('.yc-avis__score');
        if (score) {
          score.classList.add('is-on');
          var pattes = score.querySelectorAll('.yc-avis__paws > *');
          for (var j = 0; j < pattes.length; j++) { pattes[j].classList.add('is-on'); await attendre(160); }
        }
        await attendre(250);
        await pose;
        y.classList.remove('is-respire');
        var clin = y.animate([{ transform: 'none' }, { transform: 'rotate(-4deg) translateY(-3px)' },
          { transform: 'rotate(-4deg) translateY(-3px)', offset: .7 }, { transform: 'none' }],
          { duration: 900, easing: 'cubic-bezier(.3,1.3,.5,1)' });
        await attendre(140);
        y.classList.add('is-cligne');
        var etincelle = y.querySelector('.yc-yumi__etincelle');
        if (etincelle) etincelle.classList.add('is-on');
        await attendre(420);
        y.classList.remove('is-cligne');
        await clin.finished;
        y.classList.add('is-respire');
      } catch (e) {
        toutMontrer(el);
      }
    }

    var guetteur = anime ? new IntersectionObserver(function (entrees) {
      entrees.forEach(function (en) {
        if (!en.isIntersecting) return;
        guetteur.unobserve(en.target);
        jouer(en.target);
      });
    }, { threshold: 0.4 }) : null;

    function preparer() {
      if (!anime) return;
      var lot = document.querySelectorAll('.yc-avis--flow');
      for (var i = 0; i < lot.length; i++) {
        var el = lot[i], y = el.querySelector('.yc-yumi'), p = el.querySelector('.yc-avis__text');
        if (!y || !p || el.classList.contains('yc-avis--anim')) continue;
        decouper(p);
        el.classList.add('yc-avis--anim');
        y.style.transform = 'translateX(140%)';
        guetteur.observe(el);
      }
    }

    /* Le decoupage en mots change a peine le nombre de lignes : on le fait
       AVANT le calage du chat, pour que l'arc tombe juste. */
    function demarrer() {
      preparer();
      toutes();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', demarrer);
    } else {
      demarrer();
    }
    /* Les polices arrivent apres le premier rendu et changent le nombre de
       lignes : on recale une fois qu'elles sont pretes. */
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(toutes);

    var minuteur;
    window.addEventListener('resize', function () {
      clearTimeout(minuteur);
      minuteur = setTimeout(toutes, 150);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
